import { Box, Button, Typography, useTheme, useMediaQuery } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import axios from 'axios';
import { Tooltip } from '@mui/material';
import { AuthContext } from '../../context/AuthContext';
import { useContext, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import SettingsIcon from '@mui/icons-material/Settings';

const Product = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [suppliers, setSuppliers] = useState(null);
  const { currentuser, base_url, request } = useContext(AuthContext);
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [imageUrl, setImageUrl] = useState(null);
  const [pdfUrl, setPdfUrl] = useState('');

  const config = {
    headers: {
      'Authorization': `Bearer ${currentuser.accessToken}`
    },
    responseType: 'blob',
  };

  const configBlob = {
    headers: {
      'Authorization': `Bearer ${currentuser.token}`
    },
    responseType: 'blob',
  };

  useEffect(() => {
    const fetchImage = async (image) => {
      try {
        const response = await axios.get(base_url + '/ethioglobal/product/image/' + image, configBlob);

        if (!response.status == 200) {
          throw new Error('Network response was not ok');
        }

        const imageBlob = new Blob([response.data], { type: 'image/jpeg' });
        const imageObjectURL = window.URL.createObjectURL(imageBlob);

        setImageUrl(imageObjectURL);
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };

    // console.log('new request:', request);
    const imagePath = request?.productImage.split('/')[2];
    if(imagePath) {
      fetchImage(imagePath);
    }
  }, [request]);

  // const fetchUsers = async () => {
  //   try {
  //     const res = await axios.get(`${base_url}/ethioglobal/docs/pdf/Kalegzer.pdf`, config);
      
  //     const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
  //     const pdfUrl = window.URL.createObjectURL(pdfBlob);
  //     setPdfUrl(pdfUrl);
  //   } catch (error) {}
  // };

  // useEffect(() => {
  //   fetchUsers();
  // }, []);

  const fetchSuppliers = async () => {
    try {
      const response = await axios.post(`${base_url}/ethioglobal/suppliers/all`, config);
      setSuppliers(response.data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  const handleApprove = () => {
    console.log("Approved");
  };

  const handleReject = () => {
    console.log("Rejected");
  };

  return (
    <Box m="20px">
      {imageUrl ? (
        <Box mt="20px">
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography>
                Supplier:
                <Link to={`#`} style={{ textDecoration: 'underline', color: '#1976d2', marginLeft: '14px' }}>
                  {request?.company.companyname}
                </Link>
              </Typography>
            </Box>
            {imageUrl &&
            <Box sx={{ overflow: 'hidden', marginTop: 1, marginLeft: ''}}>
              <img src={imageUrl} alt="Fetched" style={{ width: 'auto', height: '450px' }} />
            </Box>
            }
        </Box>
      )
      :
      <Box>
        <Typography>The supplier didn't upload any documents yet.</Typography>
      </Box>
      }
    </Box>
  );
};

const overflowCellStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export default Product;